<!--Automatiquement classé par raison sociale, possibilité de classer par les 2 colonnes-->
<h2>Sociétés</h2>

<table class="table table-sm table-bordered">
    <thead>
        <th (click)="sortby('raison_sociale')" scope="col">Raison sociale</th>
        <th (click)="sortby('code_ebp')" scope="col">Code Divalto</th>
    </thead>
    <tbody>
        <ng-container *ngIf="companies">
        <ng-container *ngFor="let company of companies">
            <tr routerLink="/company" *ngIf="company">
                <td>{{ company.NOM.trim() }}</td>
                <td>{{ company.TIERS }}</td>
            </tr>
        </ng-container>
    </ng-container>
    </tbody>
</table>